<template>
    <b-overlay
            :show="loading"
            spinner-variant="primary"
            spinner-type="grow"
            rounded="sm"
    >
        <validation-observer ref="simpleRules">
            <b-row>
                <b-col cols="12" class="mb-3">
                    <b-row>
                        <b-col sm="9">
                            <validation-provider
                                    #default="{ errors }"
                                    name="fájl"
                                    rules="required"
                                    vid="file"
                            >
                                <b-form-file
                                        v-model="file"
                                        @input="selectFile"
                                        :placeholder="placeholder"
                                        drop-placeholder="A fájlt húzza ide..."
                                        browse-text="Tallózás"
                                        :accept="mimes"
                                />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-col>
                        <b-col sm="3">
                            <b-button
                                    v-if="file"
                                    variant="danger"
                                    class="float-left mr-1"
                                    @click.prevent="resetForm"
                            >
                                <feather-icon
                                        icon="Trash2Icon"
                                        size="15"
                                />
                            </b-button>
                            <b-button
                                    variant="primary"
                                    type="submit"
                                    :disabled="!file"
                                    @click.prevent="save"
                            >
                                Importálás
                            </b-button>
                        </b-col>
                        <b-col v-if="beErrorMessages.file" sm="12">
                            <span class="text-danger">{{ beErrorMessages.file[0] }}</span>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </validation-observer>

        <b-row>
            <b-col id="importPreview">
                <h4>Előnézet</h4>

                <b-table-simple class="text-no-wrap">
                    <!-- 👉 table head -->
                    <thead>
                    <tr
                            style="height: 3.75rem; font-size: 22px;"
                    >
                        <th
                                v-for="(columnTitle, index) in columnTitles"
                                :key="columnTitle"
                        >
                            <span
                                    style="font-size: 14px;"
                            >
                              {{ $t(columnTitle) }}
                            </span>
                        </th>
                    </tr>
                    </thead>
                    <!-- 👉 table body -->
                    <tbody
                            v-if="Object.keys(previewData).length"
                    >
                    <tr
                            v-for="(entityRow, key, previewIndex) in previewData"
                            :key="previewIndex"
                            style="height: 3.75rem;"
                    >
                        <td
                                v-for="(property, index) in entityRow"
                                :key="index"
                        >
                            <span v-if="property.current !== null && property.current !== '' && property.current !== property.new"
                                  class="current-value">-&nbsp;{{ property.current }}</span>
                            <span v-if="property.current !== property.new" class="new-value">+&nbsp;{{
                                    property.new
                                }}</span>
                            <span v-if="property.current === property.new" class="text-base">{{
                                    property.current
                                }}</span>
                        </td>
                    </tr>
                    </tbody>

                    <tfoot v-show="!Object.keys(previewData).length">
                    <tr>
                        <td
                                :colspan="Object.keys(columnTitles).length"
                                class="text-left"
                        >
                            Az előnézethez töltsön be egy érvényes fájlt!
                        </td>
                    </tr>
                    </tfoot>
                </b-table-simple>
            </b-col>
        </b-row>

        <b-row class="mt-2">
            <b-col>
                <div class="previewErrors pb-5" v-if="Object.keys(previewErrorMessages).length">
                    <h4>Hibák</h4>
                    <p class="mb-0 text-danger" v-for="error in previewErrorMessages"> {{ error }}</p>
                </div>

                <h4>{{ $t('import.manual') }}</h4>
                <b-alert
                        variant="primary"
                        class="mb-2"
                        :show="true"
                >
                    <div class="alert-body">
                        <feather-icon
                                icon="InfoIcon"
                                class="mr-50"
                        />
                        Az alábbiakban megtalálja az Excel fájl feltöltéséhez szükséges oszlopok részletes leírását.
                        Minden egyes oszlophoz tartozik egy rövid magyarázat, amely segít megérteni, hogy milyen típusú
                        adatokat várunk az adott mezőbe. Kérjük, olvassa el figyelmesen a leírásokat, hogy a feltöltés
                        zökkenőmentesen történjen.
                    </div>
                </b-alert>
                <div v-for="(columnTitle, index) in columnTitles" :key="columnTitle">

                    <h6>{{ columnTitle }} ({{ columns[index] }})</h6>

                    <b-list-group class="mb-2">
                        <b-list-group-item
                                v-for="columnDefinition in columnDefinitions[stringHelper.convertToCamelCase(columns[index])]"
                                :key="columnDefinition"
                        >
                            <div v-html="getDefinitionTranslation(columnDefinition)"/>
                        </b-list-group-item>
                    </b-list-group>
                </div>
            </b-col>
        </b-row>
    </b-overlay>
</template>

<script>
import {
    BButton,
    BCol,
    BFormFile,
    BOverlay,
    BRow,
    BCollapse,
    BCard,
    BListGroup,
    BListGroupItem,
    BAlert,
    BTableSimple,
    VBToggle,
} from "bootstrap-vue";
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {required} from '@validations'
import stringHelper from "@/libs/helper/stringHelper";

export default {
    name: 'ImportSkeleton',
    components: {
        BAlert,
        BCol,
        BRow,
        BButton,
        BFormFile,
        BOverlay,
        BCollapse,
        BCard,
        BListGroup,
        BListGroupItem,
        BTableSimple,
        ValidationProvider,
        ValidationObserver,
        VBToggle
    },
    directives: {
        'b-toggle': VBToggle,
    },
    props: [
        'modelType',
        'columns',
        'columnTitles',
        'columnDefinitions',
        'parentLoading',
        'parentIsFileValid',
        'previewData',
        'previewErrorMessages',
        'beErrorMessages',
        'withZip'
    ],
    emits: ['file-selected', 'reset', 'saved'],
    data() {
        return {
            file: undefined,
            isFileValid: false,
            loading: false,
            openedPanelIndex: 0,
            required,
            stringHelper,
        }
    },
    watch: {
        parentLoading(newValue) {
            this.loading = newValue
        },
        parentIsFileValid(newValue) {
            this.isFileValid = newValue
        }
    },
    computed: {
        mimes() {
            if (this.withZip) {
                return 'application/zip'
            }

            return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv,application/vnd.oasis.opendocument.spreadsheet'
        },
        placeholder() {
            if (this.withZip) {
                return 'Válasszon ki vagy húzzon ide egy ZIP fájlt'
            }

            return 'Válasszon ki vagy húzzon ide egy Excel fájlt'
        }
    },
    methods: {
        selectFile(file) {
            if (file) {
                this.file = file
                this.loadPreview(file)
            }
        },
        loadPreview(file) {
            this.isFileValid = false
            this.$emit('file-selected', file)
        },
        save() {
            if (this.file) {
                this.$emit('saved', this.file)
                this.resetForm()
            }
        },
        getDefinitionTranslation(columnDefinition) {
            if (columnDefinition.includes(':')) {
                const key = columnDefinition.split(':')[0]
                let value = columnDefinition.slice(columnDefinition.indexOf(':') + 1)

                if (key === 'in') {
                    const valuesArray = value.replace(/"/g, '').split(',')
                    const formattedValues = `<ul>${valuesArray.map(item => `<li>${item.trim()}</li>`).join('')}</ul>`
                    return this.$t(`import.columnDefinitions.${key}`, {values: formattedValues})
                }

                if (key === 'required_if') {
                    let otherKey = value.split(',')[0]
                    let realValue = value.split(',')[1]
                    return this.$t(`import.columnDefinitions.${key}`, {key: otherKey, value: realValue})
                }

                if (key === 'regex') {
                    if (value.includes('jpe?g') || value.includes('webp') || value.includes('png')) {
                        return 'Csak JPG, PNG vagy WEBP kiterjesztésű fájl engedélyezett';
                    }
                }

                if (key === 'required_with') {
                    return this.$t(`import.columnDefinitions.${key}`, {field: value.trim()})
                }

                if (key === 'before_or_equal') {
                    return this.$t(`import.columnDefinitions.${key}`, {date: value.trim()})
                }

                if(key === 'min' || key === 'max') {
                    value = value.replace('.', ',')
                }

                return this.$t(`import.columnDefinitions.${key}`, {[key]: value})
            } else {
                return this.$t(`import.columnDefinitions.${columnDefinition}`)
            }
        },
        resetForm() {
            this.loading = false
            this.isFileValid = false
            this.file = undefined
            this.$emit('reset')
            this.$refs.simpleRules.reset()
        }
    }
}
</script>

<style scoped lang="scss">
.current-value,
.new-value {
  display: block;
  width: 100%;
}

.current-value {
  background: #FFDBDB;
  color: #18171B;
}

.new-value {
  background: #AEFDCD;
  color: #18171B;
  font-weight: bold;
}

#importPreview {
  max-width: 100%;
  overflow-y: scroll;
}

</style>
